/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  area_division_id: z.number(),
  work_subtype_id: z.number(),
  name: z.string(),
  mix_ratio_definition_id: z.number().nullable(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const WorkDetailBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type WorkDetailBase = z.infer<typeof base>;
export type WorkDetailBasePutPayload = z.infer<typeof put>;
export type WorkDetailBasePatchPayload = z.infer<typeof patch>;
export type WorkDetailBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type WorkDetailBaseCreateAttributes = z.infer<typeof create>;
export type WorkDetailBaseUpdateAttributes = z.infer<typeof update>;
export type WorkDetailBaseCacheAttributes = z.infer<typeof cache>;
export type WorkDetailBaseCachesAttributes = z.infer<typeof caches>;